import { createSlice } from '@reduxjs/toolkit';

export const CommonStoreKey = 'CommonStore';

const initialState = {
    impersonateUser: null,
    currentIndex: 0,
    answerResponse: [],
    apiTokens: {},
    loginToken: {},
    language: '',
    languageList: [],
    zipcodeCountyList: {}
};

const policySlice = createSlice({
    name: CommonStoreKey,
    initialState: initialState,
    reducers: {
        addSearchValInStore: (state, action) => ({
            ...state,
            searchVal: action.payload
        }),
        addRoleValInStore: (state, action) => ({
            ...state,
            roleVal: action.payload
        }),
        updateVersionAvailInStore: (state, action) => ({
            ...state,
            hasUpdatedVersion: action.payload
        }),
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setCurrentIndex: (state, action) => {
            state.currentIndex = action.payload;
        },
        setAnswersResponse: (state, action) => {
            if (!Array.isArray(state.answerResponse)) {
                state.answerResponse = [];
            }

            action.payload.forEach((newResponse) => {
                const existingIndex = state.answerResponse.findIndex((response) => response.quesId === newResponse.quesId);

                if (existingIndex !== -1) {
                    state.answerResponse[existingIndex] = newResponse;
                } else {
                    state.answerResponse.push(newResponse);
                }
            });
        },
        clearAnswersResponse: (state) => {
            state.answerResponse = [];
        },
        setApiTokens: (state, action) => {
            state.apiTokens = { ...action.payload };
        },
        setLoginCredential: (state, action) => {
            state.loginToken = { ...action.payload };
        },
        setLanguageList: (state, action) => {
            state.languageList = [...action.payload];
        },
        removeAPIData(state, action) {
            const storeKey = action.payload;
            state[storeKey] = null;
        },
        addZipcodeCountiesInStore: (state, action) => ({
            ...state,
            zipcodeCountyList: action.payload
        }),

        resetStore: () => initialState
    }
});

const { actions, reducer: commonReducer } = policySlice;
export const {
    addSearchValInStore,
    addRoleValInStore,
    updateVersionAvailInStore,
    setCurrentIndex,
    setAnswersResponse,
    clearAnswersResponse,
    setApiTokens,
    resetStore,
    setLanguage,
    removeAPIData,
    setLanguageList,
    setLoginCredential,
    addZipcodeCountiesInStore
} = actions;
export default commonReducer;
